import { render } from "./ClassInfo.vue?vue&type=template&id=0df06841"
import script from "./ClassInfo.vue?vue&type=script&lang=js"
export * from "./ClassInfo.vue?vue&type=script&lang=js"

import exportComponent from "/home/randreu/projects/gringo/UPlanner/QRAsistencia/apps/qr-asistencia/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__